import { waLink, WA_DEFAULT_MESSAGE, SITE, track } from "@/constants/site";
import Reveal from "@/components/base/Reveal";

export default function FinalCTA() {
  return (
    <section className="relative overflow-hidden bg-primary-950">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 opacity-[0.06]"
        style={{
          backgroundImage:
            "radial-gradient(circle at 80% 20%, oklch(var(--primary-400)) 0, transparent 40%), repeating-linear-gradient(115deg, oklch(var(--primary-400)) 0, oklch(var(--primary-400)) 1px, transparent 1px, transparent 48px)",
        }}
      />
      <div className="relative mx-auto w-full max-w-4xl px-4 py-20 text-center md:px-6 md:py-28">
        <Reveal>
          <h2 className="font-heading text-3xl font-extrabold leading-tight tracking-tight text-background-50 md:text-5xl">
            Sua operação precisa continuar em movimento.
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base text-background-100/85 md:text-lg">
            Fale com a Power e encontre a solução adequada para seu motor ou equipamento.
          </p>
          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <a
              href={waLink(WA_DEFAULT_MESSAGE)}
              target="_blank"
              rel="noreferrer"
              onClick={() => track("whatsapp_click")}
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-[#25D366] px-7 py-4 text-base font-bold text-background-50 transition-colors hover:bg-[#1fb959]"
            >
              <i className="ri-whatsapp-line text-xl" aria-hidden="true" />
              Solicitar orçamento no WhatsApp
            </a>
            <a
              href={SITE.phoneHref}
              onClick={() => track("phone_click")}
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 px-7 py-4 text-base font-bold text-background-50 transition-colors hover:bg-background-50/10"
            >
              <i className="ri-phone-line text-xl" aria-hidden="true" />
              Ligar agora
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}